var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceUpdateStatusDialog.title", {
    title: _vm.report.title
  })) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-window', {
    model: {
      value: _vm.step,
      callback: function callback($$v) {
        _vm.step = $$v;
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.ReportClearanceUpdateStatusSteps.FORM
    }
  }, [_c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceUpdateStatusDialog.text")) + " ")]), _c('v-row')], 1), _c('v-divider', {
    staticClass: "d-none d-md-block",
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceUpdateStatusDialog.seller")) + " ")]), _vm.sellerCompany && _vm.sellerCompany.loading && _vm.sellerCompany.isSharedContentLoading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "image",
      "height": "133"
    }
  }) : _vm.sellerCompany && _vm.sellerCompany.id ? _c('company-sheet', {
    attrs: {
      "company": _vm.sellerCompany
    }
  }) : _c('m-no-content')], 1)], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "outlined": "",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createAndClose();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceUpdateStatusDialog.create")) + " ")]), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading,
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.createReportAndSend();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceUpdateStatusDialog.createAndSend")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ReportClearanceUpdateStatusSteps.SEND_MAIL
    }
  }, [_c('v-card-text', [_vm.ReportClearanceUpdateStatusSteps.SEND_MAIL === _vm.step ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_CLEARANCE_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.clearance.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.clearance.seller ? [_vm.clearance.seller.email] : [],
      "refs": [{
        refId: _vm.clearance.id,
        refType: _vm.ResourceEnum.CLEARANCE
      }, {
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true,
      "attachmentFileFilters": _vm.attachmentFileFilters
    }
  }) : _vm._e()], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "loading": _vm.requestsLoading
    },
    on: {
      "click": function click() {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }